import { Link } from "react-router-dom";
import "./ajouterProduit.css";
import Sidebare from "../Sidbare/Sidebare";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import * as XLSX from "xlsx";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";

const AjouterProduit: React.FC<ArticleInfo & { loading?: boolean }> = ({
  setDesignation,
  setPrixVenteArticleTTC,
  setDescription,
  setstock,
  setRefARticle,
  handleImage,
  handleSubmit,
  setUnite,
  messageError,
  loading,
}) => {
  const [columns, setColumns] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [MessageSucess, setMessageSucess] = useState<string>("");
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const categories = [
    "Pièces automobiles",
    "Constructeur",
    "Maintenance et réparation",
    "Outils industriels",
    "Equipements",
    "Lubrifiants",
    "Huiles",
  ];

  const expectedColumns = [
    "IdArticle", "Designation", "RefArticle",
    "PrixVenteArticleTTC", "image", "stock", "réduction",
  ];

  /* ── Category helpers ─────────────────────────────── */
  const toggleCategory = (category: string) => {
    setSelectedCategories((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };

  const removeCategory = (category: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedCategories((prev) => prev.filter((c) => c !== category));
  };

  /* ── Click outside dropdown ───────────────────────── */
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node))
        setIsOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  /* ── Responsive ───────────────────────────────────── */
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ── Image preview ────────────────────────────────── */
  const handleImageWithPreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleImage?.(e);
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => setImagePreview(ev.target?.result as string);
      reader.readAsDataURL(file);
    }
  };

  /* ── Excel upload ─────────────────────────────────── */
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const data = event.target?.result;
      if (!data) return;
      try {
        const workbook = XLSX.read(data, { type: "binary" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        let DataAricle = XLSX.utils.sheet_to_json(sheet);
        DataAricle = DataAricle.map((article: any) => ({
          ...article,
          image: article.image ?? null,
          réduction: article.réduction ?? 0,
          stock: article.stock ?? 0,
        }));

        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        if (jsonData.length > 0) {
          const uploadedColumns = jsonData[0] as string[];
          setColumns(uploadedColumns);
          const missing = expectedColumns.filter((col) => !uploadedColumns.includes(col));
          if (missing.length > 0) {
            flash(setErrorMessage, `Colonnes manquantes : (${missing.join(", ")})`);
            return;
          }
        }

        const response = await axios.post(
          `${process.env.REACT_APP_PHP_APP_URL}/upload-excel-aricles`,
          DataAricle
        );

        if (response.status === 200) {
          const { updates, creates, duplicates } = response.data;
          if (duplicates.length > 0)
            flash(setErrorMessage, `Doublon ignoré — IdArticle : ${duplicates[0].IdArticle}`);
          const msg = [
            updates > 0 ? `${updates} articles mis à jour.` : "",
            creates > 0 ? `${creates} articles créés.` : "",
          ].filter(Boolean).join(" ");
          flash(setMessageSucess, msg);
        }
      } catch (error: any) {
        if (error.response?.status === 400) {
          flash(setErrorMessage, `Doublons détectés : ${JSON.stringify(error.response.data.duplicates)}`);
        } else {
          alert("Erreur lors du téléchargement des données.");
        }
      }
    };
    reader.readAsBinaryString(file);
  };

  const flash = (setter: (v: string) => void, msg: string, duration = 3500) => {
    setter(msg);
    setTimeout(() => setter(""), duration);
  };

  const handleGoBack = () => window.history.back();

  /* ── Shared alerts ────────────────────────────────── */
  const Alerts = () => (
    <>
      {errorMessage && (
        <div className="apa-u-alert apa-u-alert-error">
          <i className="bi bi-exclamation-triangle-fill" />
          <span>{errorMessage}</span>
        </div>
      )}
      {MessageSucess && (
        <div className="apa-u-alert apa-u-alert-success">
          <i className="bi bi-check2-circle" />
          <span>{MessageSucess}</span>
        </div>
      )}
      {messageError && (
        <div className="apa-u-alert apa-u-alert-error">
          <i className="bi bi-exclamation-triangle-fill" />
          <span>{messageError}</span>
        </div>
      )}
    </>
  );

  /* ══════════════════════════════════════════════════
     MOBILE VIEW
  ══════════════════════════════════════════════════ */
  if (isMobile) {
    return (
      <>
        <NewSideBarAdmin />
        {loading && (
          <div className="apa-u-loader-overlay">
            <div className="apa-u-spinner" />
            <div className="apa-u-loader-text">Chargement en cours...</div>
          </div>
        )}
        <div className="apa-u-mobile-wrapper">

          {/* Header */}
          <div className="apa-u-mobile-header">
            <h3 className="apa-u-mobile-title">Ajouter un produit</h3>
            <div className="apa-u-mobile-divider" />
          </div>

          <form onSubmit={handleSubmit} className="apa-u-mobile-form">

            {/* Image upload */}
            <div
              className={`apa-u-dropzone ${dragOver ? "apa-u-dropzone-active" : ""} ${imagePreview ? "apa-u-dropzone-filled" : ""}`}
              onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
              onDragLeave={() => setDragOver(false)}
              onDrop={(e) => { e.preventDefault(); setDragOver(false); }}
            >
              {imagePreview ? (
                <img src={imagePreview} alt="preview" className="apa-u-dropzone-preview" />
              ) : (
                <>
                  <div className="apa-u-dropzone-icon">
                    <i className="bi bi-cloud-arrow-up" />
                  </div>
                  <p className="apa-u-dropzone-text">Importer une photo de produit</p>
                  <p className="apa-u-dropzone-hint">png, jpg, jpeg…</p>
                </>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={handleImageWithPreview}
                className="apa-u-dropzone-input"
              />
            </div>

            {/* Product name */}
            <div className="apa-u-field">
              <label className="apa-u-label">Nom de produit</label>
              <div className="apa-u-input-wrap">
                <i className="bi bi-tag apa-u-input-icon" />
                <input
                  type="text"
                  className="apa-u-input"
                  onChange={(e) => setDesignation(e.target.value)}
                  placeholder="Nom de l'article"
                  autoFocus
                />
              </div>
            </div>

            {/* Description */}
            <div className="apa-u-field">
              <label className="apa-u-label">Description</label>
              <textarea
                className="apa-u-textarea"
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Entrez la description du produit…"
              />
              <span className="apa-u-char-count">0 / 1000</span>
            </div>

            {/* Category */}
            <div className="apa-u-field">
              <label className="apa-u-label">Catégorie</label>
              <div className="apa-u-dropdown" ref={dropdownRef} onClick={() => setIsOpen(!isOpen)}>
                <div className="apa-u-dropdown-selected">
                  {selectedCategories.length === 0 ? (
                    <span className="apa-u-dropdown-placeholder">Sélectionnez des catégories</span>
                  ) : (
                    selectedCategories.map((cat, i) => (
                      <span key={i} className="apa-u-tag">
                        {cat}
                        <button
                          type="button"
                          className="apa-u-tag-remove"
                          onClick={(e) => removeCategory(cat, e)}
                        >×</button>
                      </span>
                    ))
                  )}
                </div>
                <i className={`bi bi-chevron-${isOpen ? "up" : "down"} apa-u-dropdown-arrow`} />
                {isOpen && (
                  <div className="apa-u-dropdown-menu">
                    {categories.map((cat, i) => (
                      <div
                        key={i}
                        className={`apa-u-dropdown-item ${selectedCategories.includes(cat) ? "apa-u-dropdown-item-active" : ""}`}
                        onClick={(e) => { e.stopPropagation(); toggleCategory(cat); }}
                      >
                        <div className={`apa-u-checkbox ${selectedCategories.includes(cat) ? "apa-u-checkbox-checked" : ""}`}>
                          {selectedCategories.includes(cat) && <i className="bi bi-check" />}
                        </div>
                        {cat}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Quantity + Reference */}
            <div className="apa-u-row-2">
              <div className="apa-u-field">
                <label className="apa-u-label">Quantité</label>
                <div className="apa-u-input-wrap">
                  <i className="bi bi-boxes apa-u-input-icon" />
                  <input type="text" className="apa-u-input" onChange={(e) => setstock(e.target.value)} placeholder="500" />
                </div>
              </div>
              <div className="apa-u-field">
                <label className="apa-u-label">Référence</label>
                <div className="apa-u-input-wrap">
                  <i className="bi bi-upc apa-u-input-icon" />
                  <input type="text" className="apa-u-input" onChange={(e) => setRefARticle(e.target.value)} placeholder="REF-0001" />
                </div>
              </div>
            </div>

            {/* Price + Unit */}
            <div className="apa-u-row-2">
              <div className="apa-u-field">
                <label className="apa-u-label">Prix</label>
                <div className="apa-u-input-wrap">
                  <i className="bi bi-currency-exchange apa-u-input-icon" />
                  <input type="text" className="apa-u-input apa-u-input-pad-right" onChange={(e) => setPrixVenteArticleTTC(e.target.value)} placeholder="0.00" />
                  <span className="apa-u-input-suffix">MAD</span>
                </div>
              </div>
              <div className="apa-u-field">
                <label className="apa-u-label">Unité</label>
                <div className="apa-u-input-wrap">
                  <i className="bi bi-layers apa-u-input-icon" />
                  <select className="apa-u-select" onChange={(e) => setUnite(e.target.value)}>
                    {Array.from({ length: 1000 }, (_, i) => i + 1).map((n) => (
                      <option key={n} value={n}>{n}</option>
                    ))}
                  </select>
                  <i className="bi bi-chevron-down apa-u-select-arrow" />
                </div>
              </div>
            </div>

            {/* Excel import */}
            <button
              type="button"
              className="apa-u-btn-excel"
              onClick={() => document.getElementById("upload-mobile")?.click()}
            >
              <i className="bi bi-file-earmark-spreadsheet" />
              Importer un fichier Excel
              <i className="bi bi-download" />
            </button>
            <input
              type="file" accept=".xlsx,.xls"
              id="upload-mobile"
              className="apa-u-file-hidden"
              onChange={handleFileUpload}
            />

            {/* Submit */}
            <button type="submit" className="apa-u-btn-submit">
              <i className="bi bi-plus-circle" />
              Ajouter le produit
            </button>
          </form>

          <div className="apa-u-alerts-wrap"><Alerts /></div>
        </div>
      </>
    );
  }

  /* ══════════════════════════════════════════════════
     DESKTOP VIEW
  ══════════════════════════════════════════════════ */
  return (
    <>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css" />
      <NewSideBarAdmin />
      {loading && (
        <div className="apa-u-loader-overlay">
          <div className="apa-u-spinner" />
          <div className="apa-u-loader-text">Chargement en cours...</div>
        </div>
      )}
      <div className="apa-u-desktop-wrapper">
        <form onSubmit={handleSubmit} className="apa-u-desktop-form">

          {/* Top bar */}
          <div className="apa-u-topbar">
            <button type="button" className="apa-u-back-btn" onClick={handleGoBack}>
              <i className="bi bi-arrow-left-short" />
              Retour
            </button>
            <h4 className="apa-u-page-title">Ajouter un nouveau produit</h4>
          </div>

          <Alerts />

          <div className="apa-u-desktop-grid">

            {/* ── Left column ── */}
            <div className="apa-u-col-left">

              <div className="apa-u-card">
                <h6 className="apa-u-card-title">
                  <i className="bi bi-info-circle" /> Informations générales
                </h6>

                <div className="apa-u-field">
                  <label className="apa-u-label">Nom de produit</label>
                  <div className="apa-u-input-wrap">
                    <i className="bi bi-tag apa-u-input-icon" />
                    <input
                      type="text"
                      className="apa-u-input"
                      onChange={(e) => setDesignation(e.target.value)}
                      placeholder="Nom de l'article"
                    />
                  </div>
                </div>

                <div className="apa-u-field">
                  <label className="apa-u-label">Description</label>
                  <textarea
                    className="apa-u-textarea"
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Décrivez votre produit…"
                  />
                  <span className="apa-u-char-count">0 / 1000</span>
                </div>

                <div className="apa-u-field">
                  <label className="apa-u-label">Catégorie</label>
                  <div className="apa-u-input-wrap">
                    <i className="bi bi-grid apa-u-input-icon" />
                    <select
                      className="apa-u-select"
                      onChange={(e) => setSelectedCategory(e.target.value)}
                      value={selectedCategory}
                    >
                      <option value="">Sélectionnez une catégorie</option>
                      {categories.map((cat, i) => (
                        <option key={i} value={cat}>{cat}</option>
                      ))}
                    </select>
                    <i className="bi bi-chevron-down apa-u-select-arrow" />
                  </div>
                </div>

                <div className="apa-u-row-2">
                  <div className="apa-u-field">
                    <label className="apa-u-label">Quantité</label>
                    <div className="apa-u-input-wrap">
                      <i className="bi bi-boxes apa-u-input-icon" />
                      <input type="text" className="apa-u-input" onChange={(e) => setstock(e.target.value)} placeholder="500" />
                    </div>
                  </div>
                  <div className="apa-u-field">
                    <label className="apa-u-label">Référence</label>
                    <div className="apa-u-input-wrap">
                      <i className="bi bi-upc apa-u-input-icon" />
                      <input type="text" className="apa-u-input" onChange={(e) => setRefARticle(e.target.value)} placeholder="REF-0001" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Pricing card */}
              <div className="apa-u-card">
                <h6 className="apa-u-card-title">
                  <i className="bi bi-currency-exchange" /> Tarification
                </h6>
                <div className="apa-u-row-3">
                  <div className="apa-u-field">
                    <label className="apa-u-label">Prix TTC</label>
                    <div className="apa-u-input-wrap">
                      <i className="bi bi-cash apa-u-input-icon" />
                      <input
                        type="text"
                        className="apa-u-input apa-u-input-pad-right"
                        name="PrixVenteArticleTTC"
                        onChange={(e) => setPrixVenteArticleTTC(e.target.value)}
                        placeholder="0.00"
                      />
                      <span className="apa-u-input-suffix">MAD</span>
                    </div>
                  </div>
                  <div className="apa-u-field">
                    <label className="apa-u-label">Réduction (%)</label>
                    <div className="apa-u-input-wrap">
                      <i className="bi bi-percent apa-u-input-icon" />
                      <input type="number" className="apa-u-input" onChange={(e) => setUnite(e.target.value)} placeholder="0" />
                    </div>
                  </div>
                  <div className="apa-u-field">
                    <label className="apa-u-label">Unité</label>
                    <div className="apa-u-input-wrap">
                      <i className="bi bi-layers apa-u-input-icon" />
                      <select className="apa-u-select" onChange={(e) => setUnite(e.target.value)}>
                        {Array.from({ length: 1000 }, (_, i) => i + 1).map((n) => (
                          <option key={n} value={n}>{n}</option>
                        ))}
                      </select>
                      <i className="bi bi-chevron-down apa-u-select-arrow" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Right column ── */}
            <div className="apa-u-col-right">

              {/* Image upload card */}
              <div className="apa-u-card">
                <h6 className="apa-u-card-title">
                  <i className="bi bi-image" /> Photo du produit
                </h6>
                <div
                  className={`apa-u-dropzone ${dragOver ? "apa-u-dropzone-active" : ""} ${imagePreview ? "apa-u-dropzone-filled" : ""}`}
                  onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                  onDragLeave={() => setDragOver(false)}
                  onDrop={(e) => { e.preventDefault(); setDragOver(false); }}
                >
                  {imagePreview ? (
                    <>
                      <img src={imagePreview} alt="preview" className="apa-u-dropzone-preview" />
                      <div className="apa-u-dropzone-change">
                        <i className="bi bi-pencil" /> Changer
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="apa-u-dropzone-icon">
                        <i className="bi bi-cloud-arrow-up" />
                      </div>
                      <p className="apa-u-dropzone-text">Glissez une image ici</p>
                      <p className="apa-u-dropzone-hint">ou cliquez pour parcourir · png, jpg, jpeg</p>
                    </>
                  )}
                  <input
                    type="file" accept="image/*"
                    id="ImportPhotos"
                    className="apa-u-dropzone-input"
                    onChange={handleImageWithPreview}
                  />
                </div>
              </div>

              {/* Actions card */}
              <div className="apa-u-card apa-u-card-actions">
                <h6 className="apa-u-card-title">
                  <i className="bi bi-send" /> Actions
                </h6>
                <button type="submit" className="apa-u-btn-submit">
                  <i className="bi bi-plus-circle" />
                  Confirmer l'ajout
                </button>
                <button
                  type="button"
                  className="apa-u-btn-excel"
                  onClick={() => document.getElementById("upload")?.click()}
                >
                  <i className="bi bi-file-earmark-spreadsheet" />
                  Importer un fichier Excel
                  <i className="bi bi-download" />
                </button>
                <input
                  type="file" accept=".xlsx,.xls"
                  name="upload" id="upload"
                  className="apa-u-file-hidden"
                  onChange={handleFileUpload}
                />
                <p className="apa-u-excel-hint">
                  Colonnes requises : IdArticle, Designation, RefArticle, PrixVenteArticleTTC, image, stock, réduction
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AjouterProduit;